module.exports = __webpack_public_path__ + "img/popup-bg-1.e598cc7.png";